import React, { useEffect, useState, useCallback, useContext } from "react";
import api, { BASE_URL } from "../../Utils/api";
import EmpresasModal from "./EmpresasModal";
import ConfiguracoesCamposModal from "../Configuracoes/ConfiguracoesCampos/ConfiguracoesCamposModal";
import FuncionariosModal from "../Funcionarios/FuncionariosModal";
import AdicionarUsuarioEntidadeModal from "./AdicionarUsuarioEntidadeModal";
import GruposAcessoEmpresasModal from "./GruposAcessoEmpresasModal";
import EmpresasConfiguracoesModal from "./EmpresasConfiguracoesModal";
import EmpresasFinanceiroModal from "./EmpresasFinanceiroModal";
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import { FaUser, FaUserPlus, FaDollarSign, FaBan } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../../Utils/GlobalContext";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";
import {
  podeAdicionarFilial,
  podeAdicionarFornecedor,
} from "../../Utils/verificarLimiteDocumentosAtivos";


function Empresas({ classificacaoOverride }) {
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfigCamposModal, setShowConfigCamposModal] = useState(false);
  const [showFuncionariosModal, setShowFuncionariosModal] = useState(false);
  const [empresaParaFuncionario, setEmpresaParaFuncionario] = useState(null);
  const [selectedTipoForConfig, setSelectedTipoForConfig] = useState(null);
  const [tiposConfiguracao, setTiposConfiguracao] = useState([]);
  const [showAdicionarUsuarioModal, setShowAdicionarUsuarioModal] = useState(false);
  const [entidadeParaAdicionar, setEntidadeParaAdicionar] = useState(null);
  const [empresaCriada, setEmpresaCriada] = useState(null);
  const [showGruposAcessoEmpresasModal, setShowGruposAcessoEmpresasModal] = useState(false);
  const [showEmpresaConfigModal, setShowEmpresaConfigModal] = useState(false);
  const [showFinanceiroModal, setShowFinanceiroModal] = useState(false);
  const [empresaParaConfig, setEmpresaParaConfig] = useState(null);
  const [empresaParaFinanceiro, setEmpresaParaFinanceiro] = useState(null);
  const [abaInicialConfig, setAbaInicialConfig] = useState("geral");
  const token = localStorage.getItem("authToken");
  const permiteEdicao = "S";

  const { globalData } = useContext(GlobalContext);
  const { toast, confirm } = useFeedback();
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");
  const classificacao =
    classificacaoOverride || globalData?.classificacao || localStorage.getItem("classificacao");
  const isAbonada = globalData?.mensalidade_abonada === "S";

  const columns = [
    { Header: "Nome", accessor: "razao_social" },
    { Header: "Fantasia", accessor: "fantasia" },
    {
      Header: classificacao === "F" ? "CPF/CNPJ" : "CNPJ",
      accessor: "cnpj",
      Cell: ({ row }) => {
        const item = row.original || row;
        if (classificacao === "F" && item.tipo_pessoa === "PF") {
          return item.cpf || "Indefinido";
        }
        return item.cnpj || "Indefinido";
      },
    },
    { Header: "Situação", accessor: "situacao" },
  ];

  // Item #36 (LGPD): CNPJ mascarado na exportação quando o LGPD da entidade
  // ativa está ligado (null/ausente é tratado como oculto — falha segura).
  const lgpdAtivo = globalData?.lgpdOcultarDados !== false;
  const exportMaskColumns = lgpdAtivo ? { cnpj: "cnpj", cpf: "cpf" } : {};

  const fetchEmpresas = useCallback(() => {
    if (!entidadeID) return;

    const endpoint =
      classificacao === "V" ? `${BASE_URL}/api/empresas/ListarEmpresas/${entidadeID}` :
      classificacao === "E" ? `${BASE_URL}/api/empresas/ListarEntidades/${entidadeID}` :
      classificacao === "F" ? `${BASE_URL}/api/empresas/ListarFornecedores/${entidadeID}` :
                              `${BASE_URL}/api/empresas/ListarEmpresas/${entidadeID}`;

    api
      .get(endpoint, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        const empresasComPermissao = (response.data?.data || []).map((empresa) => ({
          ...empresa,
          permiteEdicao,
        }));
        setEmpresas(empresasComPermissao);
      })
      .catch((error) => {
        console.error("Erro ao buscar as empresas:", error);
      });
  }, [classificacao, entidadeID, token]);

  useEffect(() => {
    fetchEmpresas();
  }, [fetchEmpresas]);

  const fetchTiposConfiguracao = useCallback(() => {
    if (!entidadeID || !token) return;
    api
      .get(`${BASE_URL}/api/configuracaoCampos/ListarTiposConfiguracoesCampos/${entidadeID}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setTiposConfiguracao(Array.isArray(res.data?.data) ? res.data.data : []))
      .catch(() => setTiposConfiguracao([]));
  }, [entidadeID, token]);

  useEffect(() => {
    fetchTiposConfiguracao();
  }, [fetchTiposConfiguracao]);

  const getTipoConfigIdForClassificacao = useCallback(() => {
    const nome = (n) => (n || "").toLowerCase();
    if (classificacao === "V") {
      const t = tiposConfiguracao.find(
        (c) =>
          nome(c.nome).includes("vinculad") ||
          nome(c.descricao).includes("vinculad") ||
          (nome(c.nome).includes("empresa") && !nome(c.nome).includes("entidade"))
      );
      return t?.id;
    }
    if (classificacao === "E") {
      const t = tiposConfiguracao.find(
        (c) =>
          nome(c.nome).includes("entidade") || nome(c.descricao).includes("entidade")
      );
      return t?.id;
    }
    if (classificacao === "F") {
      const t = tiposConfiguracao.find(
        (c) =>
          nome(c.nome).includes("fornecedor") || nome(c.descricao).includes("fornecedor")
      );
      return t?.id;
    }
    return tiposConfiguracao[0]?.id;
  }, [classificacao, tiposConfiguracao]);

  const handleOpenConfigCampos = (empresa) => {
    const id =
      empresa?.id_tipo_empresa ??
      empresa?.id_tipo_fornecedor ??
      getTipoConfigIdForClassificacao();
    if (id != null) {
      setSelectedTipoForConfig({ id });
      setShowConfigCamposModal(true);
    }
  };

  const handleOpenEmpresaConfiguracoes = (empresa) => {
    setEmpresaParaConfig(empresa);
    setAbaInicialConfig("geral");
    setShowEmpresaConfigModal(true);
  };

  const handleOpenFinanceiro = (empresa) => {
    setEmpresaParaFinanceiro(empresa);
    setShowFinanceiroModal(true);
  };

  const handleCloseConfigCampos = () => {
    setShowConfigCamposModal(false);
    setSelectedTipoForConfig(null);
  };

  const handleCloseConfigCamposEAbrirGrupos = () => {
    setShowConfigCamposModal(false);
    setSelectedTipoForConfig(null);
    if (empresaCriada) {
      setShowGruposAcessoEmpresasModal(true);
    }
  };

  const handleCloseGruposAcesso = () => {
    setShowGruposAcessoEmpresasModal(false);
    setEmpresaCriada(null);
    fetchEmpresas();
  };

  const handleEdit = (empresa) => {
    setSelectedEmpresa(empresa);
    setShowModal(true);
  };

  const abrirModalNovaEmpresa = () => {
    setSelectedEmpresa(null);
    setShowModal(true);
  };

  const handleAddFilial = async () => {
    const pode = await podeAdicionarFilial({
      baseUrl: BASE_URL,
      token,
      entidadeID,
      toast,
    });
    if (!pode) return;

    abrirModalNovaEmpresa();
  };

  const handleAddFornecedor = async () => {
    const pode = await podeAdicionarFornecedor({
      baseUrl: BASE_URL,
      token,
      entidadeID,
      toast,
    });
    if (!pode) return;

    abrirModalNovaEmpresa();
  };

  const handleAdd =
    classificacao === "F" ? handleAddFornecedor : handleAddFilial;

  const handleClose = (createdEmpresa) => {
    setShowModal(false);
    setSelectedEmpresa(null);
    fetchEmpresas();
    if (createdEmpresa) {
      setEmpresaCriada({ id: createdEmpresa.id, nome: createdEmpresa.nome });
      if (createdEmpresa.idTipoConfiguracao) {
        setSelectedTipoForConfig({ id: createdEmpresa.idTipoConfiguracao });
        setShowConfigCamposModal(true);
      } else {
        setShowGruposAcessoEmpresasModal(true);
      }
    }
  };

  const handleAbrirFuncionarios = (empresa) => {
    setEmpresaParaFuncionario(empresa);
    setShowFuncionariosModal(true);
  };

  const handleAbrirAdicionarUsuario = (empresa) => {
    setEntidadeParaAdicionar(empresa);
    setShowAdicionarUsuarioModal(true);
  };

  const handleExcluir = async (empresa) => {
    const nome = empresa.fantasia || empresa.razao_social || empresa.id;
    const confirmado = await confirm(
      `Tem certeza que deseja excluir "${nome}"?`,
      "Excluir Empresa",
      "warning"
    );
    if (!confirmado) return;

    try {
      await api.delete(
        `${BASE_URL}/api/empresas/ExcluirEmpresa/${empresa.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            id_entidade: entidadeID,
          },
        }
      );
      fetchEmpresas();
    } catch (error) {
      console.error("Erro ao excluir:", error);
      toast.error(error.response?.data?.message || "Erro ao excluir. Tente novamente.");
    }
  };

  // Item #33 — inativação lógica de filial (classificacao='V'), com cascata de
  // documentos/anexos no backend. Distinta de handleExcluir (exclusão física).
  const handleInativar = async (empresa) => {
    const nome = empresa.fantasia || empresa.razao_social || empresa.id;
    const confirmado = await confirm(
      `Deseja inativar a empresa "${nome}"?\n\nTodos os documentos vinculados serão arquivados e seus anexos serão permanentemente removidos. Esta ação é irreversível quanto aos anexos.`,
      "Inativar Empresa",
      "warning"
    );
    if (!confirmado) return;

    try {
      const { data } = await api.put(
        `${BASE_URL}/api/empresas/InativarEmpresa/${empresa.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            id_entidade: entidadeID,
          },
        }
      );
      toast.success(
        `Empresa "${nome}" inativada. ${data.documentos_inativados} documento(s) arquivado(s), ${data.anexos_removidos} anexo(s) removido(s).`
      );
      fetchEmpresas();
    } catch (error) {
      console.error("Erro ao inativar:", error);
      toast.error(error.response?.data?.message || "Erro ao inativar. Tente novamente.");
    }
  };

  const titulo =
    classificacao === "V"
      ? "Cadastro de Filiais"
      : classificacao === "E"
      ? "Cadastro de Empresas Entidades"
      : classificacao === "F"
      ? "Cadastro de Empresas Fornecedores"
      : "Cadastro de Empresas";

  return (
    <div>
      <PageHeader titulo={titulo} path="/Empresas" classificacao={classificacao} />
      <GridPadrao
        columns={columns}
        data={empresas}
        onEdit={(configuracao) => handleEdit(configuracao, permiteEdicao)}
        onInactivate={handleExcluir}
        onConfigCampos={classificacao === "E" ? handleOpenEmpresaConfiguracoes : handleOpenConfigCampos}
        exportMaskColumns={exportMaskColumns}
        {...(classificacao !== "E" && { onAdd: handleAdd })}
        {...(classificacao === "F" && { addDataTour: "fornecedores-adicionar" })}
        {...(classificacao === "V" && { addDataTour: "filiais-adicionar" })}
        {...(classificacao === "V" && { configCamposDataTour: "filiais-config-campos" })}
        {...(classificacao === "F" && {
          onAcao: handleAbrirFuncionarios,
          acaoTitulo: "Funcionários",
          AcaoIcone: FaUser,
          acaoVariant: "outline-secondary",
        })}
        {...(classificacao === "E" && {
          onAcao: handleAbrirAdicionarUsuario,
          acaoTitulo: "Adicionar Usuário",
          AcaoIcone: FaUserPlus,
          acaoVariant: "outline-primary",
        })}
        {...(classificacao === "E" && !isAbonada && {
          onAcao2: handleOpenFinanceiro,
          acao2Titulo: "Financeiro",
          Acao2Icone: FaDollarSign,
          acao2Variant: "outline-success",
        })}
        {...(classificacao === "V" && {
          onAcao: handleInativar,
          acaoTitulo: "Inativar",
          AcaoIcone: FaBan,
          acaoVariant: "outline-danger",
        })}
      />

      <EmpresasModal
        show={showModal}
        handleClose={handleClose}
        empresa={selectedEmpresa}
        fetchEmpresas={fetchEmpresas}
        classificacaoOverride={classificacaoOverride}
      />

      <ConfiguracoesCamposModal
        show={showConfigCamposModal}
        handleClose={empresaCriada ? handleCloseConfigCamposEAbrirGrupos : handleCloseConfigCampos}
        configuracao={selectedTipoForConfig}
        fetchConfiguracoes={fetchEmpresas}
      />

      <GruposAcessoEmpresasModal
        show={showGruposAcessoEmpresasModal}
        handleClose={handleCloseGruposAcesso}
        idEmpresa={empresaCriada?.id}
        nomeEmpresa={empresaCriada?.nome}
        idEntidade={entidadeID}
      />

      <EmpresasFinanceiroModal
        show={showFinanceiroModal}
        handleClose={() => {
          setShowFinanceiroModal(false);
          setEmpresaParaFinanceiro(null);
        }}
        entidadeID={empresaParaFinanceiro?.id || entidadeID}
        empresaNome={
          empresaParaFinanceiro?.fantasia ||
          empresaParaFinanceiro?.razao_social ||
          ""
        }
        onAbrirPlanos={() => {
          // Fecha o Financeiro e abre Preferências da Entidade já na aba Plano,
          // para a mesma entidade que estava sendo visualizada.
          const empresa = empresaParaFinanceiro;
          setShowFinanceiroModal(false);
          setEmpresaParaFinanceiro(null);
          setEmpresaParaConfig(empresa);
          setAbaInicialConfig("plano");
          setShowEmpresaConfigModal(true);
        }}
      />

      <EmpresasConfiguracoesModal
        show={showEmpresaConfigModal}
        handleClose={() => {
          setShowEmpresaConfigModal(false);
          setEmpresaParaConfig(null);
          setAbaInicialConfig("geral");
        }}
        empresaId={empresaParaConfig?.id}
        entidadeID={entidadeID}
        empresaNome={empresaParaConfig?.fantasia || empresaParaConfig?.razao_social}
        abaInicial={abaInicialConfig}
      />

      <FuncionariosModal
        show={showFuncionariosModal}
        handleClose={() => {
          setShowFuncionariosModal(false);
          setEmpresaParaFuncionario(null);
        }}
        funcionario={null}
        fetchFuncionarios={() => {}}
        defaultEmpresaId={empresaParaFuncionario?.id}
      />

      <AdicionarUsuarioEntidadeModal
        show={showAdicionarUsuarioModal}
        onClose={() => { setShowAdicionarUsuarioModal(false); setEntidadeParaAdicionar(null); }}
        entidade={entidadeParaAdicionar}
      />
    </div>
  );
}

export default Empresas;
